/* eslint-disable @typescript-eslint/no-explicit-any */
import axios from 'axios';
import { environment } from '../../config/environment.ts';

// ----- Existing Step Content Type -----
interface StepContentFields {
  type: 'step1' | 'step2' | 'step3' | 'button';
  data: {
    title?: string;
    description?: string;
    labels?: Record<string, string>;
    buttons?: Record<string, string>;
    errors?: Record<string, string | Record<string, string>>;
    messages?: Record<string, string>;
    pinPrompt?: string;
    textPrompt?: string;
    success?: string;
  };
}

export interface FooterLink {
  text: string;
  url: string;
  internal?: boolean;
}

export interface FooterContent {
  note: string;
  disclaimer: string[];
  links: FooterLink[];
}

const getContentfulUrl = () => {
  const {
    contentfulKeys: {
      spaceId,
      DeliveryToken,
      PreviewToken,
      environment: env,
    },
    endpoints: {
      contentfulPreviewUrl,
      contentfulDeliveryUrl,
    },
  } = environment;

  const appEnv = import.meta.env.VITE_APP_ENV || 'localdev';

  console.log("appEnv:", appEnv);

  // Use Preview for dev, Delivery for others
  const isDev = appEnv === 'localdev' || appEnv === 'development';

  const baseUrl = isDev ? contentfulPreviewUrl : contentfulDeliveryUrl;
  const token = isDev ? DeliveryToken : PreviewToken;

  return `https://${baseUrl}/spaces/${spaceId}/environments/${env}/entries?access_token=${token}&content_type=page&include=6`;
};


// ----- Fetch Page Translations (Steps) -----
export const fetchPageContent = async (): Promise<Record<string, StepContentFields['data']>> => {
  const url = getContentfulUrl();

  const resp = await axios.get(url);


  return resp.data;
};

// ----- Fetch Footer Content -----
export const fetchFooterContent = async (): Promise<{ items: any[]; includes: any }> => {
  const url = getContentfulUrl();
  try {
    const resp = await axios.get(url);
    const items = resp.data.items;
    const includes = resp.data.includes;


    // extract footer data here (if needed separately)
    return {
      items,
      includes,
    };
  } catch (err) {
    console.error('❌ Error fetching footer content:', err);
    return { items: [], includes: { Entry: [] } };
  }
};
